
import React from 'react';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "./AgendaUnaCita.css"
//import Info from './Modal';
//import Tarjeta from './Tarjeta';

import { useLocation } from "react-router-dom";


import Tarjeta from './Tarjeta';

export default function AgendaUnaCita() {

  const location = useLocation()

  return (<>
    <h1 className='title'>Encuentra un Abogado</h1>
    {/* <div id='bar-filtros' className='bar-filtros'>
      <h2 className='filtros-title'>Filtros</h2>
      <div className='d-flex'>
        <div className='row flex-start filter-group '>
          <select className='select-filter' defaultValue={1}>
            <option className='option-filter' value={1}>Especialidad</option>
          </select>
          <select className='select-filter ' defaultValue={3}>
            <option className='option-filter' value={3}>Estado</option>
          </select>
        </div>
      </div>
    </div> */}
    <div className='mt-5 container contenedor'>
      <div className="mt-5 card">
        <Tarjeta state={location.state}/>
      </div>
    </div>
  </>);
}

/*
Especialidad.
Estado.
Calificación que se vea, pero que no sea filtro.

        <DataTable value={lawyers} tableStyle={{ minWidth: '50rem' }}>
          <Column field="Nombre" header="Nombre" ></Column>
          <Column field="Especialidad" header="Especialidad"></Column>
          <Column field="Calificacion" header="Calificación" ></Column>
          <Column field="Estado" header="Estado" ></Column>
          <Column field="Info" header=""></Column>
        </DataTable>
*/


